import React, { useContext } from "react";
import { flatMapDeep, max } from "lodash";
import moment from "moment";
import { oc } from "ts-optchain";
import { useRootSelector } from "@/infrastructure/hooks";
import { FireSel, FireType } from "@/features/firestore";
import { useWatchListUpdate } from "@/features/applications/hook";

export const WatchlistContext = React.createContext<{
  unfilteredData: FireType.IntradayData[];
  watchlistData: FireType.IntradayData[];
  lastUpdate: string;
  country: string[];
  setCountry: (e: string[]) => void;
  activeKey: string;
  setActiveKey: (e: string) => void;
}>({
  unfilteredData: [],
  watchlistData: [],
  lastUpdate: "",
  country: [],
  setCountry: () => {},
  activeKey: "",
  setActiveKey: () => {}
});

export const useWatchListContext = () => useContext(WatchlistContext);

export const useIntraday = (country: string[], activeKey: string) => {
  const intraday = useRootSelector(FireSel.intradayData);
  const { userWatchlist } = useWatchListUpdate();
  const countryExchange = useRootSelector(FireSel.countryExchange);
  const exchanges = countryExchange.filter(e => country.includes(e.country)).flatMap(e => e.exchanges);

  const watchlistData = intraday
    ? flatMapDeep(exchanges, exc =>
        Object.keys(intraday)
          .filter(k => k.toUpperCase().includes(exc))
          .map(k => oc(intraday[k]).data([]).filter(e => e.trading_code))
      )
    : [];

  return {
    intraday,
    unfilteredData: watchlistData,
    watchlistData:
      activeKey === "all"
        ? watchlistData
        : userWatchlist[activeKey]
        ? watchlistData.filter(
            w => !!userWatchlist[activeKey].find(s => s.ticker === w.trading_code && s.exchange === w.exchange)
          )
        : [],
    lastUpdate: intraday
      ? moment(
          max(
            flatMapDeep(exchanges, exc =>
              Object.keys(intraday)
                .filter(k => k.toUpperCase().includes(exc))
                .map(k => new Date(oc(intraday[k]).data[0].time("2020-01-01")))
            )
          )
        ).format("lll")
      : "Data not updated..."
  };
};
